import React from "react";

/* The Aditi monogram — a serif 'A' framed by a champagne keyline. */
export default function Logo({ light = false, compact = false }) {
  const ink = light ? "#F9F9FB" : "#0B0B0C";
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 12 }}>
      <svg width="34" height="34" viewBox="0 0 40 40" aria-hidden="true">
        <rect x="1" y="1" width="38" height="38" rx="3" fill="none" stroke="#D4AF37" strokeWidth="1.2" />
        <text
          x="20" y="28" textAnchor="middle"
          fontFamily="Playfair Display, serif" fontSize="24" fontWeight="600" fill={ink}
        >
          A
        </text>
      </svg>
      {!compact && (
        <span style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
          <span
            style={{
              fontFamily: "Playfair Display, serif",
              fontSize: "1.18rem",
              fontWeight: 600,
              letterSpacing: "0.01em",
              color: ink,
            }}
          >
            Aditi Realty
          </span>
          <span
            style={{
              fontSize: "0.56rem",
              letterSpacing: "0.34em",
              textTransform: "uppercase",
              color: "#D4AF37",
              marginTop: 3,
            }}
          >
            Acquire · Build · Multiply
          </span>
        </span>
      )}
    </span>
  );
}
